<template>
  <div>
    <a-skeleton :loading="loading" active/>
    <a-collapse :expand-icon-position="'right'" class="pipeline">
      <a-collapse-panel v-for="(step, index) in pipeline.steps" :key="index" :header="step.name">
        <a-row :gutter="[2, 2]" type="flex" justify="start" class="line" v-for="(line, index) in step.lines" :key="index">
          <a-col :span="1"
                 style="user-select: none; border-right: 1px solid rgba(0, 0, 0, 0.2); background-color: rgba(200, 200, 200, 0.2); padding: 0 8px">
            {{ index + 1 }}
          </a-col>
          <a-col :span="23" style="padding-left: 8px">{{ line }}</a-col>
        </a-row>
        <a-badge slot="extra" :status="step.status.toLowerCase()"/>
      </a-collapse-panel>
    </a-collapse>
    <a-alert v-if="error" :message="error" type="error" show-icon/>
  </div>
</template>

<script>

import httpClient from "@/utils/httpClient";

export default {
  name: "DormPipeline",
  props: {
    script: {
      type: String,
      required: true,
    },
    dorm: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pipeline: [],
      loading: true,
      error: null
    };
  },
  mounted() {
    this.runScript()
  },
  methods: {
    runScript() {
      this.loading = true
      httpClient
          .get(`/utils/remote/${this.dorm}/scripts/${this.script}`)
          .then((response) => {
            console.log(response)
            this.pipeline = response;
          }).catch((error) => {
            console.log(error)
            let errorMessage = error.response.data.message
            if (errorMessage.startsWith("Failed to execute script (51)")) {
              this.error = `Skrypt nie został uruchomiony, ponieważ serwer "${this.dorm}" nie odpowiada. Sprawdź status usług oraz zweryfikuj poprawność konfiguracji.`
            } else if (errorMessage.contain("Failed to execute script (52)")) {
              this.error = "Podany skrypt nie istnieje."
            } else {
              this.error = errorMessage
            }
            this.$message.error("Wystąpił błąd uruchomieniem skryptu!")
          }).finally(() => {
            this.loading = false
          })
    },
  },
};
</script>

<style scoped>
.line {
  margin-bottom: 0;
  font-family: monospace, monospace;
}

.line:nth-child(even) {
  background-color: rgba(200, 200, 200, 0.15);
}

.line:hover {
  background-color: rgba(200, 200, 200, 0.25) !important;
}

</style>

<style>
.pipeline .ant-collapse-content-box {
  padding: 0;
}

.pipeline .ant-collapse-header {
  font-weight: 500;
}
</style>